import type { HttpClient, RequestConfig, ResponseApi } from '@/interfaces/http-client';
import axios, { AxiosInstance } from 'axios';
import { HttpStatusCode } from './httpClient';
import { CommonRoute } from '@/constants/routes';

export enum HTTP_STATUS_CODE {
  OK = 200,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZATION = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  SERVER_ERROR = 500,
  UN_AVAILABLE_SERVICE = 503,
  BAD_GATEWAY = 502,
}

const axiosInstance: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

const redirectLoginOfUnAuthorization = (error: unknown) => {
  if (axios.isAxiosError(error) && error.response?.status === HttpStatusCode.UNAUTHORIZED) {
    window.history.pushState({}, "", CommonRoute.RETRY);
  }
}

export const axiosClient: HttpClient = {
  async get<T>(url: string, config?: RequestConfig): Promise<ResponseApi<T>> {
    try {
      const { data, status } = await axiosInstance.get<T>(url, config);
      return { data, status_code: status };
    } catch (error: unknown) {
      redirectLoginOfUnAuthorization(error);
      throw error;
    }


  },

  async post<T>(url: string, dataRequest?: unknown, config?: RequestConfig): Promise<ResponseApi<T>> {
    try {
      const { data, status } = await axiosInstance.post<T>(url, dataRequest, config);
      return { data, status_code: status };
    } catch (error: unknown) {
      redirectLoginOfUnAuthorization(error);
      throw error;
    }
  },

  async put<T>(url: string, dataRequest?: unknown, config?: RequestConfig): Promise<ResponseApi<T>> {
    try {
      const { data, status } = await axiosInstance.put<T>(url, dataRequest, config);
      return { data, status_code: status };
    } catch (error: unknown) {
      redirectLoginOfUnAuthorization(error);
      throw error;
    }
  },

  async patch<T>(url: string, dataRequest?: unknown, config?: RequestConfig): Promise<ResponseApi<T>> {
    try {
      const { data, status } = await axiosInstance.patch<T>(url, dataRequest, config);
      return { data, status_code: status };
    } catch (error: unknown) {
      redirectLoginOfUnAuthorization(error);
      throw error;
    }
  },

  async delete<T>(url: string, config?: RequestConfig): Promise<ResponseApi<T>> {
    try {
      const { data, status } = await axiosInstance.delete<T>(url, config);
      return { data, status_code: status };
    } catch (error: unknown) {
      redirectLoginOfUnAuthorization(error);
      throw error;
    }
  },
};

export const httpClient = axiosClient;